import { Controller } from "@hotwired/stimulus";

// Goal form: toggle amount vs percent (last month) vs percent (12-mo avg); live preview for both percent modes.
export default class extends Controller {
  static targets = ["revenueFields", "percentFields", "percentInput", "previewAmount", "twelveMonthAvgFields", "twelveMonthPreviewAmount"];
  static values = { lastMonthCents: Number, twelveMoAvgCents: Number };

  connect() {
    this.toggleFromRadio();
    this.updatePreview();
  }

  toggle() {
    this.toggleFromRadio();
  }

  toggleFromRadio() {
    const selected = this.element.querySelector('input[name="account[goal_type]"]:checked')?.value || "revenue_target";

    if (this.hasRevenueFieldsTarget && this.hasPercentFieldsTarget) {
      this.revenueFieldsTarget.classList.toggle("hidden", selected !== "revenue_target");
      this.percentFieldsTarget.classList.toggle("hidden", selected !== "percent_growth");

      const revInput = this.revenueFieldsTarget.querySelector("input");
      const pctInput = this.percentFieldsTarget.querySelector("input");
      if (revInput) revInput.disabled = selected !== "revenue_target";
      if (pctInput) pctInput.disabled = selected !== "percent_growth";
    }
    if (this.hasTwelveMonthAvgFieldsTarget) {
      this.twelveMonthAvgFieldsTarget.classList.toggle("hidden", selected !== "twelve_month_avg_growth");
      const twelveMonthInput = this.twelveMonthAvgFieldsTarget.querySelector("input");
      if (twelveMonthInput) twelveMonthInput.disabled = selected !== "twelve_month_avg_growth";
    }
    this.updatePreview();
  }

  updatePreview() {
    const selected = this.element.querySelector('input[name="account[goal_type]"]:checked')?.value || "revenue_target";
    const formatDollars = (cents) =>
      (cents / 100).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });

    if (selected === "percent_growth" && this.hasPreviewAmountTarget && this.hasLastMonthCentsValue && this.lastMonthCentsValue > 0) {
      const pctInput = this.element.querySelector('input[name="account[revenue_growth_goal_percent]"]');
      const pct = parseFloat(pctInput?.value || 0);
      this.previewAmountTarget.textContent = (isNaN(pct) || pct <= 0) ? "—" : formatDollars(Math.round(this.lastMonthCentsValue * (1 + pct / 100)));
    }

    if (selected === "twelve_month_avg_growth" && this.hasTwelveMonthPreviewAmountTarget && this.hasTwelveMoAvgCentsValue && this.twelveMoAvgCentsValue > 0) {
      const pctInput = this.element.querySelector('input[name="account[twelve_month_avg_growth_percent]"]');
      const pct = parseFloat(pctInput?.value || 0);
      this.twelveMonthPreviewAmountTarget.textContent = (isNaN(pct) || pct <= 0) ? "—" : formatDollars(Math.round(this.twelveMoAvgCentsValue * (1 + pct / 100)));
    }
  }
}
